import { MAX_MOBILE_WIDTH } from "@/constants/breakpoints";

function isMobile() {
    return window && window.innerWidth <= MAX_MOBILE_WIDTH
}

export { isMobile }